import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { deleteMcpConnector } from '@/services/mcp-gateway';

export function useDeleteMcpConnector() {
  const queryClient = useQueryClient();
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useMutation({
    mutationFn: (connectorId: string) => deleteMcpConnector(connectorId, orgId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['mcp-connectors', orgId] });
    },
  });
}
